import { Component, computed, inject, input } from '@angular/core';
import { FormControl, FormGroup, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { InfoPopoverComponent } from 'app/shared/components/info-popover/info-popover.component';

@Component({
  selector: 'ez-payment-method-selection-element',
  imports: [ReactiveFormsModule, InfoPopoverComponent],
  templateUrl: './payment-method-selection-element.component.html',
  styleUrl: './payment-method-selection-element.component.scss',
})
export class PaymentMethodSelectionElementComponent {
  private readonly rootFormGroup = inject(FormGroupDirective);

  get form(): FormGroup {
    return this.rootFormGroup.control;
  }

  readonly controlName = input.required<string>();
  readonly value = input.required<string>();
  readonly label = input.required<string>();
  readonly iconSrc = input.required<string>();
  readonly popoverText = input.required<string>();

  readonly formControl = computed(() => this.form.controls[this.controlName()] as FormControl);
}
